

Acr = window.Acr || {};

Acr.ShoppingTools = (function (window, $) {
  var $shoppingToolsLandingPage;
  var $footer;
  var initialized = false;

  var landingPageAttachParameters = function () {
    var $links;
    var parameters;
    var appendParameters = '';

    if (window.location.href.indexOf('?') >= 0) {
      $links = $shoppingToolsLandingPage
        .find('.acr-model-current-picture-anchor, '
            + '.acr-model-current-primary-cta');
      parameters = window.location.href
        .slice(window.location.href.indexOf('?') + 1).split('&');

      parameters.forEach(function (param) {
        appendParameters += (appendParameters === '' ? '' : '&') + param;
      });

      $links.each(function (key) {
        $links[key].href += ($links[key].href.match(/\?/) ? '&' : '?')
          + appendParameters;
      });
    }
  };

  var init = function () {
    $shoppingToolsLandingPage = $('.acr-shopping-tools-landing');

    // Attach parameters from the query string to the Shopping Tools landing
    // page. Also making sure this is only called once.
    if ($shoppingToolsLandingPage.length > 0 && !initialized) {
      landingPageAttachParameters();
    }
    initialized = true;
  };

  return {
    init: init,
  };
}(window, window.$));
